import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup , Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { UnitDetailsComponent } from '../unit-details/unit-details.component';

@Component({
  selector: 'app-addquota',
  templateUrl: './addquota.component.html',
  styleUrls: ['./addquota.component.css']
})
export class AddquotaComponent implements OnInit {
  pipe = new DatePipe('en-US');
  erorrSchduleMassage = false
  weeksArr = [ 
    {
      name: "Sat",
      value : 0,
      title:"saturday"
    },
    {
      name: "Sun",
      value : 0,
      title:"sunday"
    },
    {
      name: "Mon",
      value : 0,
      title:"monday"
    },
    {
      name: "Tue",
      value : 0,
      title:"tuesday"
    },
    {
      name: "Wed",
      value : 0,
      title:"wednesday"
    },
    {
      name: "Thu",
      value : 0,
      title:"thursday"
    },
    {
      name: "Fri",
      value : 0,
      title:"friday"
    },
  ]

  showQuotaStatus = true
  weekDays = new FormGroup({})
  prioritySchudle:any = 0
  valid_fromSchdule:any = ""
  valid_toSchdule:any = ""
  Choose_Priority_schdule = "Choose Priority"

  // 

  quotaData:any
  Choose_Priority = "Choose Priority"
  priorityNumber = 0
  quotaQuantity = 0
  constructor( public dialogRef: MatDialogRef<UnitDetailsComponent>,){
  }
  ngOnInit(){
    this.buildForm()

  }

  buildForm() {
    this.weeksArr.forEach((element:any) => {
      this.weekDays.addControl(element.title, new FormControl('', [
        Validators.required
      ]))
    });

  }

  changeQutoa(event:any){
    this.showQuotaStatus = !this.showQuotaStatus
    this.erorrSchduleMassage = false
  }

  addQuotaByDay(){
    if(this.quotaData != "" && this.quotaQuantity != 0 && this.priorityNumber != 0){
      let data = {
        visit_date :  this.pipe.transform(this.quotaData, 'YYYY-MM-dd'),
        quota : this.quotaQuantity,
        priority : this.priorityNumber
      }
      this.erorrSchduleMassage = false
      this.dialogRef.close(data);
    }else {
      this.erorrSchduleMassage = true
    }
  }

  getPriority(name:string ,number:number){
    this.Choose_Priority = name
    this.priorityNumber = number
  }



  // schucle


  getPrioritySchudle(name:string ,number:number){
    this.Choose_Priority_schdule = name
    this.prioritySchudle = number
  }

  addQuotaSchudle(){

    if(this.weekDays.valid && this.valid_fromSchdule != "" && this.valid_toSchdule != "" && this.prioritySchudle != 0){
      let data = {
        valid_from : this.pipe.transform(this.valid_fromSchdule, 'YYYY-MM-dd'),
        valid_to :  this.pipe.transform(this.valid_toSchdule, 'YYYY-MM-dd'),
        week_days : this.weekDays.value,
        priority : this.prioritySchudle
      }
      this.erorrSchduleMassage = false
      this.dialogRef.close(data);
    }else {
      this.erorrSchduleMassage = true
    }

  }
}
